import { LeagueInfo } from "../../Models/LeagueInfo/LeagueInfo";
import { getRegionNameById, getLeagueNameWithoutCountry } from "../../helpers";
import { LibConfig } from "../../init";
import { urlFormatter } from "sb-resp-utils";
var LeaguesParser = /** @class */ (function () {
    function LeaguesParser() {
    }
    LeaguesParser.prototype.parseData = function (league) {
        return new LeagueInfo(this.prepareData(league));
    };
    LeaguesParser.prototype.prepareData = function (league) {
        var optionalData = this.getOptionalData(league);
        var urlCode = urlFormatter.getLeagueUrl(league.name ? league.name : "");
        var regionName = getRegionNameById(league.regionId || "", LibConfig.allRegions);
        return {
            ID: optionalData.id,
            Name: league.name || "",
            SortID: optionalData.defaultOrder,
            RankID: optionalData.defaultOrder,
            MasterEvents: [],
            LiveMasterEvents: [],
            hasCombos: false,
            EventTypes: [],
            IsHot: league.isTopLeague || false,
            hasLiveEvents: this.getHasLiveEvents(league),
            visible: true,
            isExpanded: false,
            CountryID: optionalData.regionId,
            BranchID: optionalData.sportId,
            Code: urlCode,
            hasLiveStream: this.getHasLiveStream(league),
            BranchName: league.sportName || "",
            CountryCode: optionalData.regionId,
            hasFastMarkets: false,
            CountryTranslatedName: regionName,
            MasterLeagueID: optionalData.masterLeagueId,
            UrlCode: urlCode,
            isUserCountry: this.getIsUserCountry(league),
            EventsCount: this.getEventsCount(league),
            LeagueNameWithoutCountry: getLeagueNameWithoutCountry(league, regionName)
        };
    };
    LeaguesParser.prototype.getHasLiveEvents = function (league) {
        return (league.liveFixturesTotalCount !== undefined && league.liveFixturesTotalCount > 0)
            || (league.liveOutrightsTotalCount !== undefined && league.liveOutrightsTotalCount > 0);
    };
    LeaguesParser.prototype.getHasLiveStream = function (league) {
        return league.tags !== undefined && league.tags.indexOf("LiveStream") > -1;
    };
    LeaguesParser.prototype.getIsUserCountry = function (league) {
        return league.regionId !== undefined && LibConfig.regionIds.indexOf(league.regionId) > -1;
    };
    LeaguesParser.prototype.getEventsCount = function (league) {
        return (league.fixturesTotalCount || 0) + (league.outrightsTotalCount || 0);
    };
    LeaguesParser.prototype.getOptionalData = function (league) {
        return {
            id: league.id ? parseInt(league.id) : 0,
            regionId: league.regionId ? parseInt(league.regionId) : 0,
            masterLeagueId: league.masterLeagueId ? parseInt(league.masterLeagueId) : 0,
            sportId: league.sportId ? parseInt(league.sportId) : 0,
            defaultOrder: league.defaultOrder || 0
        };
    };
    return LeaguesParser;
}());
export { LeaguesParser };
//# sourceMappingURL=LeaguesParser.js.map